// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"35":"89cad3ed","97":"49b74e94","122":"2f8ba3ac","203":"822b2f06","301":"2583fad7","629":"5c375cba","688":"d9acad58","727":"f161e892","808":"db1a86c8","910":"726f31f1","940":"72422c68","997":"24e9b6b0"}[chunkId] + ".chunk.js";
};